'use client';

import dynamic from 'next/dynamic';

const PdfPreview = dynamic(() => import('./PdfPreviewClient'), {
  ssr: false,
});

export default PdfPreview;
